  
  <div class="flex-container-col">
    <div class="row text-center" fxLayout="row">
      <div fxFlex>
          <img class="mt-5 mb-4" src="assets/img/brand.svg" alt="brand" width="144" height="144">
      </div>
    </div>
    <div class="row text-center" fxLayout="row">
        <div fxFlex></div>
        <div fxFlex class="">
      
            <mat-card class="login-card">
              <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="text-center">
                <div>
                  <mat-form-field appearance="fill">
                    <mat-label>Email</mat-label>
                    <input type="email" formControlName="username" matInput placeholder="Ingrese su email" required
                      aria-label="Email">
                  </mat-form-field>
                </div>
            
                <div>
                  <mat-form-field appearance="fill">
                    <mat-label>Password</mat-label>
                    <input type="password" formControlName="password" matInput placeholder="Ingrese su password" required
                      aria-label="Password">
                  </mat-form-field>
                </div>
            
                <mat-error *ngIf="error" class="error-message">{{ error }}</mat-error>
            
                <div class="d-flex justify-content-around mt-3 mb-4">
                  <button mat-stroked-button color="primary" type="submit" aria-label="Iniciar Sesión">Iniciar Sesión</button>
                </div>
            
                <div class="d-flex justify-content-around text-muted">
                  <small><a href="" aria-label="Recuperar password">Recuperar password</a></small>
                </div>
              </form>
            </mat-card>
          
        </div>
        <div fxFlex></div>
      <br>
    </div>
  </div>

